module.exports = __webpack_public_path__ + "img/preview-desktop.7b36c072.svg";